import './shared/styles/App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from 'react-router-dom';
//import SlideRoutes from 'react-slide-routes';
import { useEffect } from 'react';
import Login from './pages/login';
import Campaign from './pages/campaign';
import Orchestrator from './pages/orchestrator';
import OrchestratorDisplay from './pages/display';
import OrchestratorPlayer from './pages/orchestrator-player';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const isDisplayRoute = location.pathname.startsWith('/orchestrator/display');

  useEffect(() => {
    // Do not redirect when on the standalone Display route
    if (isDisplayRoute) return;
    const username = localStorage.getItem('username');
    const system = localStorage.getItem('system');
    //const campaign = localStorage.getItem('campaign');

    if (username && system) {
      if (system === 'orchestrator') {
        navigate('/orchestrator');
      } else if (system === 'orchestrator_user') {
        navigate('/orchestrator/player');
      } else {
        navigate('/campaign');
      }
    } else {
      navigate('/');
    }
  }, [navigate, isDisplayRoute]);

  return (
    <div className='App'>
      {isDisplayRoute ? (
        <Routes>
          <Route path='/orchestrator/display' element={<OrchestratorDisplay />} />
        </Routes>
      ) : (
        <header className='App-header'>
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/campaign' element={<Campaign />} />
            <Route path='/orchestrator' element={<Orchestrator />} />
            <Route path='/orchestrator/player' element={<OrchestratorPlayer />} />
            {/* fallback to login for any other route */}
            <Route path='*' element={<Login />} />
          </Routes>
        </header>
      )}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
